module.exports = __webpack_public_path__ + "static/media/percentage.70e42600.svg";